import useSWR from 'swr'

import fetcher from 'utils/fetcher'

const useOrderStatusHistory = ({ orderId }) => {
  const { data, isValidating, mutate } = useSWR(
    orderId
      ? `/orders/${orderId}?embed=workflow_statuses&fields=order_id|program_id`
      : null,
    fetcher,
    {
      revalidateOnFocus: false,
    }
  )

  return {
    statusHistory: data?._embedded?.workflow_statuses ?? [],
    loading:
      (!data?._embedded?.workflow_statuses && !data?.error) || isValidating,
    error: data?.error,
    mutate,
  }
}

export default useOrderStatusHistory
